<template>
    <div class="container">
        <md-dialog :md-active.sync="modEditarMoneda" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <!-- <pre>{{ infoMoneda }}</pre> -->
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.moneda}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select id="" v-model="infoMoneda.moneda" class="form-control">
                            <option value="">{{ labels.select }}</option>
                            <option v-for="tipMoneda in lstTipoMoneda" :key="tipMoneda.id" :value="tipMoneda.moneda">{{ tipMoneda.descripcion }}</option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.vigencia}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="date" v-model="infoMoneda.vigencia" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.trm}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="infoMoneda.trm" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.trmPromedio}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="infoMoneda.trm_promedio" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.valorPropio}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="infoMoneda.valor_propio" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <b-col cols="7" class="text-left">
                        <md-button class="md-accent" @click="eliminaRegistro">{{ labels.delete }}</md-button>
                    </b-col>
                    <b-col cols="3" class="text-right">
                        <md-button class="md-primary" @click="guardarMoneda">{{ labels.save }}</md-button>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                    </b-col>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
        <InacticaItem :InactivaItem="deleteMoneda" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"></InacticaItem>
    </div>
</template>

<script>
import TipoMoneda from '../../../services/TipoMoneda';
import Moneda from '../../../services/Moneda';
import InacticaItem from '../../utils/InacticaItem.vue';

export default {
    name : 'Editar',
    props: ['modEditarMoneda','infoMoneda'],
    components:{InacticaItem},
    data: () => ({
        deleteMoneda : false,
        idMoneda : null,
        lstTipoMoneda :[]
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Editar moneda',
                    save : 'Guardar',
                    close : 'Cerrar',
                    delete : 'Eliminar',
                    select : 'Seleccione...',
                    moneda : 'Moneda',
                    vigencia : 'Vigencia',
                    trm : 'TRM',
                    trmPromedio : 'TRM promedio',
                    valorPropio : 'Valor propio'
                }
            }else{
                return {
                    title : 'Edit currency',
                    save : 'Save',
                    close : 'Close',
                    delete : 'Delete',
                    select : 'Select...',
                    moneda : 'Currency',
                    vigencia : 'Validity',
                    trm : 'TRM',
                    trmPromedio : 'Average trm',
                    valorPropio : 'Self value'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        cierraModalDelet(){
            this.deleteMoneda = false
        },
        guardarMoneda(){
            // console.log('guardarMoneda');
            const dataForm = [
                this.infoMoneda.moneda,
                this.infoMoneda.vigencia,
                this.infoMoneda.trm,
                this.infoMoneda.trmPromedio,
                this.infoMoneda.valorPropio
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{

                let info = {
                    'id'            :   this.infoMoneda.id,
                    'moneda'        :   this.infoMoneda.moneda,
                    'vigencia'      :   this.infoMoneda.vigencia,
                    'trm'           :   this.infoMoneda.trm,
                    'trmPromedio'   :   this.infoMoneda.trm_promedio,
                    'valorPropio'   :   this.infoMoneda.valor_propio,
                    'idUser'        :   this.$store.state.userId
                }   
                // console.log(info);
                Moneda.updateMonedaById(info)
                .then((res) => {
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location. reload()
                    }
                })
                .catch((err) => console.log(err))
            }
        },
        eliminaRegistro(){
            this.idMoneda = this.infoMoneda.id
            this.deleteMoneda = true
        },
        confirmInactivate(){
            Moneda.deleteMoneda(this.idMoneda)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    location. reload()                
                }
            })
            .catch((error) => error)
        }

    },
    mounted(){
        TipoMoneda.getAllTipoMoneda()
        .then((res) => {
            // console.log(res.data);
            this.lstTipoMoneda = res.data.listTipoMoneda
        })
        .catch((err) => console.log(err))
    }
}
</script>

<style>

</style>